import { makeStyles } from '@material-ui/core';
import { asg } from '../theme/tokens';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
    // The sidebar ground is asg.navy (see modules/theme, palette.navigation).
    color: asg.white,
  },
});

/**
 * The ASG mark, knockout-white variant (files/brand/asg-icon-mono-white.svg in
 * the governance repo). The centre disc is a mask hole, not a white fill, so
 * the navy sidebar shows through it.
 */
export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 360 360"
      role="img"
      aria-label="ASG Advisory Services"
    >
      <mask id="asgHoleIcon">
        <rect width="360" height="360" fill="white" />
        <circle cx="180" cy="180" r="52" fill="black" />
      </mask>
      <g
        mask="url(#asgHoleIcon)"
        fill="none"
        stroke="currentColor"
        strokeWidth="74"
        strokeLinecap="round"
      >
        <line x1="180" y1="180" x2="52" y2="52" />
        <line x1="180" y1="180" x2="52" y2="308" />
        <line x1="180" y1="180" x2="308" y2="52" />
        <line x1="180" y1="180" x2="308" y2="308" />
      </g>
    </svg>
  );
};
